import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, object, string } from "yup";

export type DrawerIncomeFormType = {
  readonly clientId: string;
};

export const getDrawerIncomeFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<DrawerIncomeFormType> = (t) => {
  return object({
    clientId: string().required(t(Resources.Validation.Required)),
  }).defined();
};
